import { Suspense, useEffect } from 'react';

import { useBoundStore } from 'app/store';
import { FallbackWithLogo } from 'shared/ui';

import { RECEIPT_DETAIL_LOADING_TEXT } from '../config';
import { useGetPayDetailStatementCheck } from '../model';

import { Detail } from './Detail';
import { Expired } from './Expired';
import { Issue } from './Issue';

export const ReceiptDetailGateway = () => {
  const serviceParams = useBoundStore((state) => state['medicalReceipt'].serviceParams);
  const { setDetailReceiptStatus } = useBoundStore((state) => state.medicalReceipt);

  const { data } = useGetPayDetailStatementCheck({
    hspId: serviceParams.hspId,
    mpiKey: serviceParams.mpiKey,
    receivePaymentId: serviceParams.receivePaymentId,
    medicalInsuranceType: serviceParams.medicalInsuranceType,
  });

  useEffect(() => {
    setDetailReceiptStatus(data.detail_statement_check_status);
  }, [data.detail_statement_check_status]);

  if (data.detail_statement_check_status === 'NONE') {
    return (
      <Suspense
        fallback={<FallbackWithLogo title={RECEIPT_DETAIL_LOADING_TEXT.CHECK} subTitle='잠시만 기다려주세요.' />}
      >
        <Issue />
      </Suspense>
    );
  }
  if (data.detail_statement_check_status === 'VALID') {
    return (
      <Suspense
        fallback={<FallbackWithLogo title={RECEIPT_DETAIL_LOADING_TEXT.CHECK} subTitle='잠시만 기다려주세요.' />}
      >
        <Detail />
      </Suspense>
    );
  }
  if (data.detail_statement_check_status === 'EXPIRED') {
    return <Expired />;
  }

  return null;
};
